import { store } from 'store';
import {
  notificationsActions,
  NotificationSeverity,
} from 'state/notifications';

const { dispatch } = store;
const { ADD_NOTIFICATION } = notificationsActions;

// eslint-disable-next-line import/prefer-default-export
export const sendErrorNotification = (
  errorName: string,
  message: string,
  errorCount: number,
  callback?: () => void
): void => {
  dispatch(
    ADD_NOTIFICATION({
      id: `${errorName}#${errorCount}`,
      message,
      notificationSeverity: NotificationSeverity.error,
      isClosableByUser: true,
    })
  );
  if (callback) {
    callback();
  }
};

export const sendSuccessNotification = (
  successName: string,
  message: string,
  successCount: number,
  callback?: () => void
): void => {
  dispatch(
    ADD_NOTIFICATION({
      id: `${successName}#${successCount}`,
      message,
      notificationSeverity: NotificationSeverity.success,
      isClosableByUser: true,
    })
  );
  if (callback) {
    callback();
  }
};
